import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Profile.css";
import { Avatar } from "@material-ui/core";
import { auth, storage, db } from "../service/firebase";
import { useHistory } from "react-router";

function Profile() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [signUpEmail, setSignUpEmail] = useState("");
  const [signUpPassword, setSignUpPassword] = useState("");
  const [username, setUsername] = useState("");
  const [progress, setProgress] = useState(0);
  const [profilePic, setProfilePic] = useState(null);
  const [gender, setGender] = useState("");
  const [fullname, setFullname] = useState("");
  const [dob, setDob] = useState("");

  const [user, setUser] = useState(null);

  useEffect(() => {
    auth.onAuthStateChanged(function (authUser) {
      if (authUser) {
        // User is signed in.
        setUser(authUser);
      } else {
        // No user is signed in.
        setUser(null);
      }
    });
  }, []);

  useEffect(() => {
    const isGender = gender === "Male";
    const maleProfile = "man.png";
    const femaleProfile = "woman.png";
    if (isGender) {
      setProfilePic(maleProfile);
    } else {
      setProfilePic(femaleProfile);
    }
  }, [gender]);

  const loginUser = (e) => {
    e.preventDefault();
    auth
      .signInWithEmailAndPassword(email, password)
      .then(() => {
        toast.success("Loged In Successfully");
        setEmail("");
        setPassword("");
      })
      .catch(function (error) {
        setError(error.message);
      });
  };

  const signUpUser = (e) => {
    e.preventDefault();
    db.collection("users")
      .doc(username)
      .get()
      .then((doc) => {
        if (doc.exists) {
          setError("Username Already Taken");
        } else {
          auth
            .createUserWithEmailAndPassword(signUpEmail, signUpPassword)
            .then((authUser) => {
              toast.success("Sign Up Successful ");
              setError("");
              setUsername("");
              setGender("");
              setSignUpEmail("");
              setSignUpPassword("");
              setDob("");
              setFullname("");
              db.collection("users").doc(username).set({
                user: username,
                userId: authUser.user.uid,
                profileImg: profilePic,
                gender: gender,
                email: signUpEmail,
                fullname: fullname,
                dob: dob,
                bio: "",
                visible: "true",
              });
              authUser.user.updateProfile({
                displayName: username,
                photoURL: profilePic,
                email: signUpEmail,
              });
              auth.currentUser.sendEmailVerification().then(() => {
                toast.info("email verification is send to your E-mail");
              });
            });
        }
      })
      .catch(function (error) {
        setError(error.message);
      });
  };

  const handleChange = (e) => {
    if (e.target.files[0]) {
      setProfilePic(e.target.files[0]);
    }
  };

  const handleChangePic = () => {
    const uploadProfile = storage
      .ref(`profilePics/${profilePic.name}`)
      .put(profilePic);

    uploadProfile.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress(progress);
      },
      (error) => {
        alert(error.message);
      },
      () => {
        storage
          .ref("profilePics")
          .child(profilePic.name)
          .getDownloadURL()
          .then((url) => {
            db.collection("users").doc(user.displayName).update({
              profileImg: url,
            });
            auth.currentUser.updateProfile({
              photoURL: url,
            });

            setProgress(0);
            setProfilePic(null);
            toast.success("Profile Pic Updated successfully");
          });
      }
    );
  };
  const loginBtn = !email || !password;
  const signUpBtn = !username || !signUpEmail || !signUpPassword || !gender;

  const history = useHistory();
  const signOutBtn = () => {
    auth.signOut().then(() => {
      history.push("/");
    });
  };
  return (
    <div className="d-flex">
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div
        className="btn-group"
        role="group"
        aria-label="Button group with nested dropdown"
      >
        <div className="btn-group" role="group">
          <button
            id="btnGroupDrop1"
            type="button"
            className="btn dropdown-toggle text-light d-flex align-items-center"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {user?.displayName ? (
              <Avatar
                className="mr-2 avatar"
                alt="..."
                src={auth?.currentUser?.photoURL}
              />
            ) : (
              ""
            )}
            {user?.displayName ? user?.displayName : "Login/Register"}
          </button>
          <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
            {user ? (
              <div>
                {/*  eslint-disable-next-line */}
                <a
                  className="dropdown-item"
                  style={{ cursor: "pointer" }}
                  data-toggle="modal"
                  data-target="#changeProfilePic"
                >
                  Change Profile
                </a>
                {/*  eslint-disable-next-line */}
                <a
                  className="dropdown-item"
                  onClick={signOutBtn}
                  style={{ cursor: "pointer" }}
                >
                  Logout
                </a>
              </div>
            ) : (
              <div>
                {/*  eslint-disable-next-line */}
                <a
                  className="dropdown-item"
                  style={{ cursor: "pointer" }}
                  data-toggle="modal"
                  data-target="#loginModal"
                >
                  Login
                </a>
                {/*  eslint-disable-next-line */}
                <a
                  className="dropdown-item"
                  style={{ cursor: "pointer" }}
                  data-toggle="modal"
                  data-target="#signUpModal"
                >
                  Sign Up
                </a>
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="changeProfilePic"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {" "}
                Change Profile Photo
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{ width: `${progress}%` }}
                  aria-valuenow={progress}
                  aria-valuemin={0}
                  aria-valuemax={100}
                >{`${progress}%`}</div>
              </div>
              <div className="form-group mt-2">
                <input
                  type="file"
                  onChange={handleChange}
                  className="form-control-file"
                  id="exampleFormControlFile1"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="submit"
                onClick={handleChangePic}
                className="btn btn-success"
              >
                {" "}
                Change Pic{" "}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="loginModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {" "}
                Login{" "}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form className="d-flex flex-column">
                {error ? (
                  <small id="validationCustom03" className="text-danger mb-3">
                    {" "}
                    {error}{" "}
                  </small>
                ) : null}
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      Email
                    </span>
                  </div>
                  <input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    className="form-control"
                    placeholder="Enter your Email..."
                    aria-label="Email"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      Password
                    </span>
                  </div>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="form-control"
                    placeholder="Enter your Password..."
                    aria-label="Password"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <button
                  type="button"
                  onClick={() => {
                    auth
                      .sendPasswordResetEmail(email)
                      .then(() => {
                        toast.info("Reset Password link is send to ur mail");
                      })
                      .catch(() => {
                        toast.error(
                          "Please enter email to send reset password"
                        );
                      });
                  }}
                  className="btn text-danger mb-1 text-right"
                >
                  Forget Password ?
                </button>
                <button
                  type="submit"
                  disabled={loginBtn}
                  onClick={loginUser}
                  className="btn btn-success"
                >
                  Login
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Sign Up Modal */}
      <div
        className="modal fade"
        id="signUpModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {" "}
                Sign Up{" "}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {error ? (
                <small id="validationCustom03" className="text-danger mb-3">
                  {" "}
                  {error}{" "}
                </small>
              ) : null}
              <form className="d-flex flex-column">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      Username
                    </span>
                  </div>
                  <input
                    type="text"
                    value={username}
                    onChange={(e) => {
                      setUsername(e.target.value);
                    }}
                    className="form-control"
                    placeholder="Enter your Username..."
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      htmlFor="inputGroupSelect01"
                    >
                      Gender
                    </label>
                  </div>
                  <select
                    className="custom-select"
                    id="inputGroupSelect01"
                    value={gender}
                    onChange={(e) => {
                      setGender(e.target.value);
                    }}
                  >
                    <option defaultValue>Choose...</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      Fullname
                    </span>
                  </div>
                  <input
                    type="text"
                    value={fullname}
                    onChange={(e) => setFullname(e.target.value)}
                    className="form-control"
                    placeholder="Enter your Fullname..."
                    aria-label="Email"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      Dob
                    </span>
                  </div>
                  <input
                    type="date"
                    value={dob}
                    onChange={(e) => setDob(e.target.value)}
                    className="form-control"
                    aria-label="Email"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      Email
                    </span>
                  </div>
                  <input
                    type="email"
                    value={signUpEmail}
                    onChange={(e) => setSignUpEmail(e.target.value)}
                    className="form-control"
                    placeholder="Enter your Email..."
                    aria-label="Email"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <div className="input-group mb-1">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      Password
                    </span>
                  </div>
                  <input
                    type="password"
                    value={signUpPassword}
                    onChange={(e) => setSignUpPassword(e.target.value)}
                    className="form-control"
                    placeholder="Enter your Password..."
                    aria-label="Password"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <small
                  id="passwordHelpBlock"
                  className="form-text text-muted mb-2"
                >
                  Password Should be atleat 6 to 20 characters
                </small>
                <button
                  type="submit"
                  disabled={signUpBtn}
                  onClick={signUpUser}
                  className="btn btn-success"
                >
                  Sign Up / verify email
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
